import { Popover, Transition } from "@headlessui/react";
import React, { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { getArtNotificationsRequest, getNotifications, updateArtNotificationsRequest } from "store/actions";
import { useSelector, useDispatch } from "react-redux";

export default function NotifyDropdown() {
  let dispatch = useDispatch();
  const [checkBlueTick, setcheckBlueTick] = useState(null);
  const [filter, setfilter] = useState({
    limit: 10,
    orderBy: "",
    order: "",
    page: 1,
    isMore: false,
  });

  const { user } = useSelector((store) => store?.Login);
  const notifications = useSelector((store) => store?.notifications?.artNotification);
  //  notifications.push( useSelector((store) => store?.notifications.artNotification))
  useEffect(() => {
    if (user._id) {
      let data = {}
      data.receiver = user._id
      const artNotificationApiCallback = (res) => {
      }
      dispatch(getArtNotificationsRequest(data, artNotificationApiCallback))
    }

  }, [user?._id])

  useEffect(() => {
    if (filter) {
      dispatch(getNotifications(filter));
    }
  }, [filter]);

  useEffect(() => {
    if (user?._id) {
      dispatch(getNotifications());
      setfilter((prev) => ({ ...prev, user_id: user?._id }));
    }
  }, [user?._id]);

  useEffect(() => {
    if (notifications?.length > 0) {
      let filterdData = notifications?.filter((d) => !d?.is_read);
      setcheckBlueTick(filterdData?.length);
    }
  }, [notifications]);

  return (
    <div className="modal_open_start position-relative">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`
                ${open
                  ? "notify_btn position-relative"
                  : "text-opacity-90 notify_btn position-relative"
                }`}
            >
              {notifications?.length > 0 && checkBlueTick !== 0 ? (
                <span className="notify_dot"></span>
              ) : null}
              <img src="/images/svg/bellIconNew.svg" width={30} alt="" />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div className="ring_notification">
                <div className="main_map_wrap">
                  {notifications?.length > 0 ? (
                    <>
                      {notifications?.map((item, index) => {
                        return (
                          <div key={index} className="main_map_div">
                            <Link
                              key={index}
                              onClick={(e) => {

                                dispatch(
                                  dispatch(updateArtNotificationsRequest({ receiver:user?._id }))
                                );
                                let data = {}
                                data.receiver = user?._id
                                const artNotificationApiCallback = (res) => {
                                }
                                dispatch(getArtNotificationsRequest(data, artNotificationApiCallback))
                              }}
                              to={item?.type === "bid" ? `/liveAuctionNft/${item?.sellItemId}` : item?.type === "sold" ? `/nftsale/${item?.sellItemId}` : item?.type === "like" ? `/nftsale/${item?.sellItemId}` : "/profile/art"}
                              // /nftsale/659fd63218d0f62036d449d9
                              // /liveAuctionNft/659e70672f715c2aff55d335

                              className=""
                            >
                              <img src="/images/svg/bellIconNew.svg" width={30} alt="" />
                              <div className="d-flex align-items-center gap-3"> 
                              <div className="text_main_div w-100">
                                <p className="text-sm position-relative">
                                  <b className="fw-semibold"> Terpnash
                                    </b>
                                </p>

                                <p className="text-xs fw-medium">{item?.content}</p>
                                <p className="date_text fw-medium">
                                  {/* {item?.created_date} */}
                                  {moment(item?.created_date)?.fromNow()}
                                </p>
                              </div>
                              {/* {!item?.is_read && (
                                      <span className="notify_dot_ontext text-success"></span>
                                    )} */}
                              </div>
                             
                            </Link>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="w-100">
                      <h5 className="collect-head">
                        No Notifications Found !!
                      </h5>
                    </div>
                  )}
                </div>
              </div>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
